const Cookie = {
    setCookie(name, value, seconds) {
        let lifetime = '';
        if (seconds) {
            lifetime = "; Max-Age=" + seconds;
        }
        document.cookie = name + "=" + value + lifetime + ";path=/" + (process.env.PUBLIC_COOKIE_DOMAIN_NAME ? (';domain=' + process.env.PUBLIC_COOKIE_DOMAIN_NAME) : '');
    },
    hasCookie(key) {
        return document.cookie.split(';').map(cookie => {
            return cookie.split('=')[0].trim();
        }).indexOf(key) >= 0;
    },
    filledCookie(key) {
        return document.cookie.split(';').filter(cookie => {
            const value = cookie.split('=')[1].trim();

            return !!value && value !== '' && value !== 'null' && value !== ' ';
        }).map(cookie => {
            return cookie.split('=')[0].trim();
        }).indexOf(key) >= 0;
    },
    getCookie(name) {
        let nameEQ = name + "=";
        let ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }

        return null;
    },
    eraseCookie(name) {
        document.cookie = name + '=; Max-Age=-99999999;path=/' + (process.env.PUBLIC_COOKIE_DOMAIN_NAME ? (';domain=' + process.env.PUBLIC_COOKIE_DOMAIN_NAME) : '');
    }
};

export default Cookie;
